import WebApp from "@twa-dev/sdk";

export function webAppAuthTokensSet(
  tokenAccess: string,
  tokenRefresh: string,
): void {
  WebApp.CloudStorage.setItem("accessToken", tokenAccess);
  WebApp.CloudStorage.setItem("refreshToken", tokenRefresh);
}
